<span *ngIf="!hasAiData">{{ categoryName }}</span>
<span *ngIf="hasAiData && matches" class="ai-verified-badge ai-match">
  <i class="far fa-brain-circuit"></i> {{ categoryName }}
</span>
<span *ngIf="hasAiData && !matches" class="ai-verified-badge ai-mismatch" [attr.data-tooltip]="mismatchReason">
  <i class="far fa-brain-circuit"></i> {{ categoryName }}
</span>
